module.exports = __webpack_public_path__ + "img/birthday.45663dcf.svg";